/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { OrganizationByInnStatusEnum } from './OrganizationByInnStatusEnum'
import {
  OrganizationByInnStatusEnumFromJSON,
  OrganizationByInnStatusEnumFromJSONTyped,
  OrganizationByInnStatusEnumToJSON,
} from './OrganizationByInnStatusEnum'

/**
 *
 * @export
 * @interface OrganizationByInn
 */
export interface OrganizationByInn {
  /**
   *
   * @type {string}
   * @memberof OrganizationByInn
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof OrganizationByInn
   */
  address: string
  /**
   * ИНН
   * @type {string}
   * @memberof OrganizationByInn
   */
  inn: string
  /**
   *
   * @type {string}
   * @memberof OrganizationByInn
   */
  ogrn: string
  /**
   *
   * @type {OrganizationByInnStatusEnum}
   * @memberof OrganizationByInn
   */
  status: OrganizationByInnStatusEnum
  /**
   *
   * @type {string}
   * @memberof OrganizationByInn
   */
  liquidationDate?: string
}

/**
 * Check if a given object implements the OrganizationByInn interface.
 */
export function instanceOfOrganizationByInn(
  value: object
): value is OrganizationByInn {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('address' in value) || value['address'] === undefined) return false
  if (!('inn' in value) || value['inn'] === undefined) return false
  if (!('ogrn' in value) || value['ogrn'] === undefined) return false
  if (!('status' in value) || value['status'] === undefined) return false
  return true
}

export function OrganizationByInnFromJSON(json: any): OrganizationByInn {
  return OrganizationByInnFromJSONTyped(json, false)
}

export function OrganizationByInnFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OrganizationByInn {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    address: json['address'],
    inn: json['inn'],
    ogrn: json['ogrn'],
    status: OrganizationByInnStatusEnumFromJSON(json['status']),
    liquidationDate:
      json['liquidationDate'] == null ? undefined : json['liquidationDate'],
  }
}

export function OrganizationByInnToJSON(value?: OrganizationByInn | null): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    address: value['address'],
    inn: value['inn'],
    ogrn: value['ogrn'],
    status: OrganizationByInnStatusEnumToJSON(value['status']),
    liquidationDate: value['liquidationDate'],
  }
}
